import { createStyles } from '@material-ui/core';
import { container } from 'assets/jss/material-kit-pro-react.jsx';

const styles = () =>
  createStyles({
    container
  });

export default styles;
